import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as modal from '../../reducers/modalReducer';
import { paymentKioskHub, getPaymentKioskLoginMode } from '../../services/paymentKiosk';
import { LOGIN_MODE } from '../../const/paymentKiosk';
import { isUser, isKioskUser } from '../../reducers/userReducer';

import { isHubConnected } from '../../selectors/paymentKioskSelectors';

import PaymentKioskConnectionWarning from '../PaymentKioskConnectionWarning';

class PaymentKioskAppWrapper extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    paymentKioskHub.initializeHub();
  }

  shouldComponentUpdate(nextProps) {
    return (
      this.props.isHubConnected !== nextProps.isHubConnected ||
      this.props.isKioskUser !== nextProps.isKioskUser ||
      this.props.isUser !== nextProps.isUser
    );
  }

  componentDidUpdate() {
    const { isHubConnected, isKioskUser, isUser, openLoginForm } = this.props;

    if (isHubConnected && isKioskUser && !isUser) {
      const paymentKioskloginMode = getPaymentKioskLoginMode();

      if (paymentKioskloginMode === LOGIN_MODE.WITH_REDIRECT) {
        openLoginForm();
      }
    }
  }

  render() {
    const { isHubConnected } = this.props;

    return (
      <div className="payment-kiosk-app-wrapper">
        {!isHubConnected && <PaymentKioskConnectionWarning />}
        {this.props.children}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isHubConnected: isHubConnected(state),
    isUser: isUser(state),
    isKioskUser: isKioskUser(state),
    isModalOpened: !!state.modal && !!state.modal.modalType
  };
};

const mapDispatchToProps = dispatch => ({
  openLoginForm: (onClose) => dispatch(modal.openModal({
    modalType: 'LOGIN_FORM',
    modalProps: {
      raisedClass: 'raise payment-kiosk-login-form'
    }
  }))
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentKioskAppWrapper);


// WEBPACK FOOTER //
// ./src/components/PaymentKioskAppWrapper/PaymentKioskAppWrapper.jsx